import { render, staticRenderFns } from "./wizards-link.vue.vue?vue&type=template&id=45f8cab6&"
import script from "./wizards-link.vue.vue?vue&type=script&lang=js&"
export * from "./wizards-link.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports